import { Component } from './component.js';

export class LoadSpinner extends Component {
  static defaultOptions = {
    componentName: 'LoadSpinner',
    label: 'Loading, please wait...'
  };

  constructor (options) {
    super($.extend({}, LoadSpinner.defaultOptions, options));

    this.el.append(
      '<div class="fulfilling-bouncing-circle-spinner"><div class="circle"></div><div class="orbit"></div></div>'
    );

    this.label = $('<span class="message">' + this.options.label + '</span>');
    this.el.append(this.label);
  }

  hide () {
    this.el.addClass('ca-ui-loadspinner--hide');
  }

  show () {
    this.el.removeClass('ca-ui-loadspinner--hide');
  }

  setLabel (label) {
    this.label.text(label || LoadSpinner.defaultOptions.label);
  }
}
